import { render } from "./SelectCategoryBR.vue?vue&type=template&id=98c465fa&scoped=true"
import script from "./SelectCategoryBR.vue?vue&type=script&lang=js"
export * from "./SelectCategoryBR.vue?vue&type=script&lang=js"

import "./SelectCategoryBR.vue?vue&type=style&index=0&id=98c465fa&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98c465fa"]])

export default __exports__